var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCancel = function SvgCancel(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9497 12.9498C10.2161 15.6834 5.78392 15.6834 3.05025 12.9498C0.316583 10.2161 0.316582 5.78394 3.05025 3.05027C5.78392 0.316602 10.2161 0.316602 12.9497 3.05027C15.6834 5.78394 15.6834 10.2161 12.9497 12.9498ZM10.8284 9.41423L9.41421 8.00002L10.8284 6.58581C11.219 6.19528 11.219 5.56212 10.8284 5.17159C10.4379 4.78107 9.80474 4.78107 9.41421 5.17159L8 6.58581L6.58579 5.17159C6.19526 4.78107 5.5621 4.78107 5.17157 5.17159C4.78105 5.56212 4.78105 6.19528 5.17157 6.58581L6.58579 8.00002L5.17157 9.41423C4.78105 9.80476 4.78105 10.4379 5.17157 10.8284C5.5621 11.219 6.19526 11.219 6.58579 10.8284L8 9.41423L9.41421 10.8284C9.80474 11.219 10.4379 11.219 10.8284 10.8284C11.219 10.4379 11.219 9.80476 10.8284 9.41423Z",
    fill: "currentColor"
  })));
};
export default SvgCancel;